import React from 'react'
import NavBarHomeDark from '../../../components/NavBar/NavBarHomeDark'
import Footer from '../../../components/Footer/Footer'
import Breadcrumbs from '../Breadcrumbs'
import MainContent from './MainContent'
import NavBarHome from '../../../components/NavBar/NavBarHome'

function CoursesSingle() {
   return (
      <div className="pt-[92px] bg-light-5 dark:bg-dark-2 flex flex-col min-h-screen">
         <NavBarHome />

         <section className="mb-16 bg-light-5">
            <MainContent />
         </section>

         <section>
            <Footer
               logo={"/Logo NextMaker.png"}
               bgColor="bg-dark-1"
               textColor="text-gray-100"
               borderColor="border-gray-400/20"
            />
         </section>
      </div>
   )
}

export default CoursesSingle